import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bc-base',
  templateUrl: './bc-base.component.html',
  styleUrls: ['./bc-base.component.scss']
})
export class BCBaseComponent implements OnInit {

  constructor() { 
    
  }

  ngOnInit(): void {
  }

}
